/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireMultiSelectAnswer } from './CustomQuestionnaireMultiSelectAnswer';
import {
  CustomQuestionnaireMultiSelectAnswerFromJSON,
  CustomQuestionnaireMultiSelectAnswerFromJSONTyped,
  CustomQuestionnaireMultiSelectAnswerToJSON,
} from './CustomQuestionnaireMultiSelectAnswer';
import type { CustomQuestionnaireRadioAnswer } from './CustomQuestionnaireRadioAnswer';
import {
  CustomQuestionnaireRadioAnswerFromJSON,
  CustomQuestionnaireRadioAnswerFromJSONTyped,
  CustomQuestionnaireRadioAnswerToJSON,
} from './CustomQuestionnaireRadioAnswer';
import type { CustomQuestionnaireQuestionForAnswer } from './CustomQuestionnaireQuestionForAnswer';
import {
  CustomQuestionnaireQuestionForAnswerFromJSON,
  CustomQuestionnaireQuestionForAnswerFromJSONTyped,
  CustomQuestionnaireQuestionForAnswerToJSON,
} from './CustomQuestionnaireQuestionForAnswer';
import type { CustomQuestionnaireFreeTextAnswer } from './CustomQuestionnaireFreeTextAnswer';
import {
  CustomQuestionnaireFreeTextAnswerFromJSON,
  CustomQuestionnaireFreeTextAnswerFromJSONTyped,
  CustomQuestionnaireFreeTextAnswerToJSON,
} from './CustomQuestionnaireFreeTextAnswer';

/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaireAnswer
 */
export interface CustomQuestionnaireAnswer {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswer
   */
  id?: number;
  /**
   *
   * @type {CustomQuestionnaireQuestionForAnswer}
   * @memberof CustomQuestionnaireAnswer
   */
  readonly question: CustomQuestionnaireQuestionForAnswer;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswer
   */
  questionId: number;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireAnswer
   */
  readonly timestamp: string;
  /**
   *
   * @type {CustomQuestionnaireRadioAnswer}
   * @memberof CustomQuestionnaireAnswer
   */
  radioAnswer?: CustomQuestionnaireRadioAnswer | null;
  /**
   *
   * @type {CustomQuestionnaireMultiSelectAnswer}
   * @memberof CustomQuestionnaireAnswer
   */
  multiSelectAnswer?: CustomQuestionnaireMultiSelectAnswer | null;
  /**
   *
   * @type {CustomQuestionnaireFreeTextAnswer}
   * @memberof CustomQuestionnaireAnswer
   */
  freeTextAnswer?: CustomQuestionnaireFreeTextAnswer | null;
}

/**
 * Check if a given object implements the CustomQuestionnaireAnswer interface.
 */
export function instanceOfCustomQuestionnaireAnswer(value: object): value is CustomQuestionnaireAnswer {
  if (!('question' in value) || value['question'] === undefined) return false;
  if (!('questionId' in value) || value['questionId'] === undefined) return false;
  if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireAnswerFromJSON(json: any): CustomQuestionnaireAnswer {
  return CustomQuestionnaireAnswerFromJSONTyped(json, false);
}

export function CustomQuestionnaireAnswerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireAnswer {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    question: CustomQuestionnaireQuestionForAnswerFromJSON(json['question']),
    questionId: json['question_id'],
    timestamp: json['timestamp'],
    radioAnswer:
      json['radio_answer'] == null ? undefined : CustomQuestionnaireRadioAnswerFromJSON(json['radio_answer']),
    multiSelectAnswer:
      json['multi_select_answer'] == null
        ? undefined
        : CustomQuestionnaireMultiSelectAnswerFromJSON(json['multi_select_answer']),
    freeTextAnswer:
      json['free_text_answer'] == null
        ? undefined
        : CustomQuestionnaireFreeTextAnswerFromJSON(json['free_text_answer']),
  };
}

export function CustomQuestionnaireAnswerToJSON(
  value?: Omit<CustomQuestionnaireAnswer, 'question' | 'timestamp'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    question_id: value['questionId'],
    radio_answer: CustomQuestionnaireRadioAnswerToJSON(value['radioAnswer']),
    multi_select_answer: CustomQuestionnaireMultiSelectAnswerToJSON(value['multiSelectAnswer']),
    free_text_answer: CustomQuestionnaireFreeTextAnswerToJSON(value['freeTextAnswer']),
  };
}
